import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AirgapAPI } from '@transcend-io/airgap.js-types';
import App from 'src/App';
import 'src/index.css';
import { ConsentProvider } from 'src/hooks/useConsentManager';

/** Pre-setup reference to window.airgap */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const airgapInit = (self as any).airgap;

/** Promise which resolves when airgap.js core API is ready */
const airgapPromise = new Promise<AirgapAPI>((resolve, reject) => {
    const timeout = setTimeout(() => {
        reject(new Error('Airgap.js initialization timed out'));
    }, 750);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ((self as any).airgap ??= {
        readyQueue: [],
        ready(callback: (airgap: AirgapAPI) => void) {
            if (this.readyQueue) {
                this.readyQueue.push(callback);
            }
        },
        ...(airgapInit as any), // eslint-disable-line @typescript-eslint/no-explicit-any
    }).ready((airgap: AirgapAPI) => {
        clearTimeout(timeout);
        resolve(airgap);
    });
});

let airgapAPI: AirgapAPI | undefined = undefined;
airgapPromise
    .then((currentAirgapAPI: AirgapAPI) => {
        airgapAPI = currentAirgapAPI;
    })
    .catch((err) => {
        console.error('Failed to initialize Airgap.js', err);
    })
    .finally(() => {
        const rootElement = document.getElementById('costco-consent-manager');
        if (rootElement) {
            createRoot(rootElement).render(
                <StrictMode>
                    <ConsentProvider airgapAPI={airgapAPI}>
                        <App />
                    </ConsentProvider>
                </StrictMode>
            );
        }
    });
